import { gql } from "@apollo/client";

export const enableMarketplaceMutation = gql`
    mutation EnableMarketplace($id: Float!) {
        enableMarketplace(id: $id)
    }
`;

export const disableMarketplaceMutation = gql`
    mutation DisableMarketplace($id: Float!) {
        disableMarketplace(id: $id)
    }
`;